<template>
    <div class="history-block">
        <div class="history-block__column">
            <p class="history-block__date-copy">{{ date }}</p>
        </div>

        <div class="history-block__column history-block__column--flex-grow">
            <p :class="['body-copy body-copy--fw-700', {'history-block__single-heading' : !infoHeadingTwo.length }]">{{ infoHeadingOne }}</p>
            <p v-if="infoContentOne.length" class="body-copy">{{ infoContentOne }}</p>
        </div>

        <div v-if="infoHeadingTwo.length > 0 || infoContentTwo.length > 0" class="history-block__column history-block__column--flex-grow">
            <p v-if="infoHeadingTwo.length > 0" class="body-copy body-copy--fw-700">{{ infoHeadingTwo }}</p>
            <p v-if="infoContentTwo.length > 0" class="body-copy history-block__word-copy">{{ infoContentTwo }}</p>
        </div>

        <div class="history-block__column history-block__column--btn" v-if="dekonstruktorHistoryButton">
            <AppButton
                :text="buttonText"
                :from="'dekonstruktor_view_report'"
                :search_token="search_token"
                :job_type="job_type"
                :trademark_cat="trademark_cat"
                :user_id="user_id"
                :keyword="infoHeadingOne"
                @btnType:view="btnType"
            />
        </div>

        <div class="history-block__column" v-if="konstruktorHistoryButton">
            <AppButton
                :text="buttonText"
                :from="'konstruktor_view_report'"
                :konstruktorName="infoContentOne"
                :konstruktorSearchId="konstruktorSearchId"
                :user_id="user_id"
                :keyword="infoHeadingOne"
                @btnType:view="btnType"
            />
        </div>
    </div>
</template>

<script>
    import AppButton from "@/components/ui/AppButton";

    export default {
        name: 'Historyblock',
        props: {
            date: {
                type: String,
                required: true
            },
            search_token:{
                type: Number,
                required: false
            },
            job_type:{
                type: Array,
                required: false
            },
            trademark_cat:{
                type: Array,
                required: false
            },
            infoHeadingOne: {
                type: String,
                default: '',
                required: true
            },
            infoContentOne: {
                type: String,
                default: '',
                required: false
            },
            infoHeadingTwo: {
                type: String,
                default: '',
                required: false
            },
            infoContentTwo: {
                type: String,
                default: '',
                required: false
            },
            buttonText: {
                type: String,
                required: false
            },
            dekonstruktorHistoryButton:{
                type: Boolean,
                required: true
            },
            konstruktorHistoryButton:{
                type: Boolean,
                required: true
            },
            konstruktorSearchId:{
                type: String,
                required: false
            },
            konstruktorName:{
                type: String,
                required: false
            }

        },
        components: {
            AppButton
        },
        data(){
            return{
                user_id: parseInt(sessionStorage.getItem('user_id')),
                // keyword:this.infoHeadingOne
            }
        },
        computed: {
            currentState: function () {
                return this.$store.state.BrandDeKonstrucktor.currentStep
            }
        },
        watch: {
            currentState: function (newVal) {
                if (newVal === 4) {
                    this.updateView(false);
                }
            }
        },
        methods: {
            /*
            This determines where the button componnt is instantiated
            */
            btnType:function(value){

                if(value.type === 'dekonstruktor'){
                    this.$store.state.BrandDeKonstrucktorSearching.selectedKeyWord = this.keyword;
                   this.$emit('update:view', false);
                }

                if(value.type  === 'konstruktor'){
                    this.$emit('update:view', false);
                }
            },

        },
    }
</script>